import { useToggle } from '~/hooks/useToggle';
import { cls } from '~/utils';

interface IWrapperActionProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}
export const WrapperAction: React.FC<IWrapperActionProps> = ({ children, ...props }) => {
  const { setFalse, setTrue, value: isHover } = useToggle(false);
  return (
    <div
      {...props}
      className={cls('cursor-pointer', {
        'bg-surface-secondary rounded-sm': isHover,
      })}
      onMouseEnter={setTrue}
      onMouseLeave={setFalse}
    >
      {children}
    </div>
  );
};
